<template>
	<div class="html" v-html="content"/>
</template>

<script>
import marked from "marked";

export default {
	props: {
		markdown: {type: String, required: true}
	},
	computed: {
		content: (t) => marked(t.markdown)
	}
};
</script>

<style  lang="scss" scoped>
.html {
	color: #182E38;

	/deep/ {
		a {
			color: #3C9195;
			text-decoration: underline;
		}
	}
}
</style>
